import React from 'react';

const ClothingEventForm = ({ formData, prices, onInputChange, onPriceChange, onAddPrice, onRemovePrice, onSubmit, isEditing }) => {

  const isFormValid = () => {
    return (
      formData.title?.trim() &&
      prices.length > 0 &&
      prices.every((p) => p.label?.trim() && p.amount !== '' && parseFloat(p.amount) >= 1)
    );
  };

  return (
    <form onSubmit={onSubmit}>

      <div className="mb-3 mt-3">
        <label htmlFor="title" className="form-label">
          Titulo del pedido
        </label>
        <input
          type="text"
          className="form-control"
          id="title"
          name="title"
          placeholder="Ej: Camiseta Independiente 2026"
          maxLength={200}
          required
          onChange={onInputChange}
          value={formData.title}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="description" className="form-label">
          Descripcion
        </label>
        <textarea
          className="form-control"
          id="description"
          name="description"
          placeholder="Ej: Pedido de camisetas oficiales temporada 2026. Talles disponibles: S, M, L, XL."
          maxLength={500}
          rows={3}
          onChange={onInputChange}
          value={formData.description}
        />
      </div>

      <hr style={{ margin: '24px 0 16px' }} />
      <h6 style={{ marginBottom: '12px', color: '#555' }}>Precios / Items</h6>

      {prices.map((price, index) => (
        <div key={index} className="row align-items-end mb-2">
          <div className="col-md-3">
            <label className="form-label" style={{ fontSize: '0.85rem' }}>Nombre del item</label>
            <input
              type="text"
              className="form-control"
              placeholder="Ej: Camiseta titular"
              maxLength={100}
              value={price.label}
              onChange={(e) => onPriceChange(index, 'label', e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label" style={{ fontSize: '0.85rem' }}>Precio completo ($)</label>
            <input
              type="number"
              className="form-control"
              placeholder="Ej: 25000"
              min={1}
              value={price.amount}
              onChange={(e) => onPriceChange(index, 'amount', e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label" style={{ fontSize: '0.85rem' }}>
              Sena ($) <span style={{ color: '#999', fontWeight: 400 }}>opcional</span>
            </label>
            <input
              type="number"
              className="form-control"
              placeholder="Ej: 10000"
              min={1}
              value={price.deposit_amount || ''}
              onChange={(e) => onPriceChange(index, 'deposit_amount', e.target.value)}
            />
          </div>
          <div className="col-md-3 d-flex gap-2">
            {prices.length > 1 && (
              <button
                type="button"
                className="btn btn-sm"
                style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '6px' }}
                onClick={() => onRemovePrice(index)}
              >
                Quitar
              </button>
            )}
          </div>
        </div>
      ))}

      <button
        type="button"
        className="btn btn-sm mb-3"
        style={{ backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '6px' }}
        onClick={onAddPrice}
      >
        + Agregar precio
      </button>

      <div className="mb-3">
        <label htmlFor="sheet_tab" className="form-label">
          Pestana de Google Sheet
        </label>
        <input
          type="text"
          className="form-control"
          id="sheet_tab"
          name="sheet_tab"
          placeholder="Ej: Indumentaria 2026"
          maxLength={100}
          onChange={onInputChange}
          value={formData.sheet_tab}
        />
        <small className="form-text text-muted">
          Nombre exacto de la pestana en la planilla donde se registran los pagos.
        </small>
      </div>

      <hr style={{ margin: '24px 0 16px' }} />
      <h6 style={{ marginBottom: '12px', color: '#555' }}>Datos bancarios (transferencia)</h6>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="bank_cbu" className="form-label">CBU</label>
          <input
            type="text"
            className="form-control"
            id="bank_cbu"
            name="bank_cbu"
            placeholder="Ej: 0000003100012345678901"
            maxLength={30}
            onChange={onInputChange}
            value={formData.bank_cbu}
          />
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="bank_alias" className="form-label">Alias</label>
          <input
            type="text"
            className="form-control"
            id="bank_alias"
            name="bank_alias"
            placeholder="Ej: filial.roja.lp"
            maxLength={50}
            onChange={onInputChange}
            value={formData.bank_alias}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label htmlFor="bank_holder" className="form-label">Titular de la cuenta</label>
          <input
            type="text"
            className="form-control"
            id="bank_holder"
            name="bank_holder"
            placeholder="Ej: Juan Perez"
            maxLength={120}
            onChange={onInputChange}
            value={formData.bank_holder}
          />
        </div>
      </div>

      <button
        type="submit"
        style={{
          backgroundColor: '#C73B33',
          borderColor: '#FF5733',
          color: '#FFF',
        }}
        className="btn"
        disabled={!isFormValid()}
      >
        {isEditing ? 'Guardar Cambios' : 'Crear Pedido Indumentaria'}
      </button>

    </form>
  );
};

export default ClothingEventForm;
